import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import {
	BusinessObjectTypeType,
	UserIdCtor,
	type UserIdType,
} from '../types.js'
import {
	jsonArrayProperty,
	jsonProperty,
	jsonClass,
} from '@sumbricht/json-class-serializer'
import { BusinessObject } from '../bos/business-object.js'
import { User } from '../auth/user.js'

export type LockObjectType = BusinessObjectTypeType
export type LockLevelType = 'read' | 'partial' | 'full' | 'exclusive'

@jsonClass('Lock')
export class Lock {
	@jsonProperty(String)
	get __type() {
		return 'Lock'
	}
	set __type(_) {}

	@jsonProperty(String)
	id?: string

	@jsonProperty(String)
	objectType!: LockObjectType

	@jsonProperty(String)
	objectName!: string

	@jsonProperty(Date)
	objectVersionDateTime?: Date

	@jsonProperty(String)
	lockLevel: LockLevelType = 'read'

	@jsonArrayProperty(String)
	subAreas: string[] = []

	@jsonProperty(() => UserIdCtor)
	userId?: UserIdType
	user?: User

	@jsonProperty(Date)
	obtainedOn?: Date

	constructor(init?: Partial<Lock>) {
		assignCommonProperties(this, init)
	}

	static forBo(bo: BusinessObject, init?: Partial<Lock>) {
		return new Lock({
			objectType: bo.__type,
			objectName: bo.getQualifiedName(),
			objectVersionDateTime: bo.updateTimestamp ?? bo.creationTimestamp,
			...init,
		})
	}
}

export const UnlockExistingTypes = ['own', 'others', 'none'] as const
export type UnlockExistingType = (typeof UnlockExistingTypes)[number]
